import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ml_price_prediction_high_wtp_i2_2~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_2/f'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_ml_price_prediction_high_wtp_i2_2~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_2/tai_chi_walking_f_v2_al'),
			},
		},
	},
]

export default config
